// https://vuex.vuejs.org/en/actions.html
import axios from "axios";

// The login action passes vuex commit helper that we will use to trigger mutations.
export default {
  login({ commit }, userData) {
    return new Promise((resolve, reject) => {
      commit("auth_request");
      axios
        .post("/account/login", {
          username: userData.username,
          password: userData.password,
        })
        .then((response) => {
          const token = response.data.token;
          const user = JSON.stringify(response.data.user);
          const role = response.data.role;
          const datetype =
            response.data.settings != undefined
              ? response.data.settings.datetype
              : "";
          const usermenu = JSON.stringify(response.data.usermenu);
          const settings = JSON.stringify(response.data.settings);
          const inboxcount = JSON.stringify(response.data.inboxcount);
          const company = JSON.stringify(response.data.company);
          // storing jwt in localStorage. https cookie is safer place to store
          localStorage.setItem("token", token);
          localStorage.setItem("user", user);
          localStorage.setItem("role", role);
          localStorage.setItem("usermenu", usermenu);
          localStorage.setItem("settings", settings);
          localStorage.setItem("datetype", datetype);
          localStorage.setItem("inboxcount", inboxcount);
          localStorage.setItem("company", company);
          axios.defaults.headers.common["Authorization"] = "Bearer " + token;
          // mutation to change state properties to the values passed along
          commit("auth_success", {
            token,
            user,
            role,
            usermenu,
            settings,
            datetype,
            inboxcount,
            company,
          });
          resolve(response);
        })
        .catch((err) => {
          commit("auth_error");
          localStorage.removeItem("token");
          reject(err);
        });
    });
  },
  updateInboxCount({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("client/inbox/pending/count")
        .then((response) => {
          const inboxcount = JSON.stringify(response.data);
          localStorage.setItem("inboxcount", inboxcount);
          commit("set_inbox_count", { inboxcount });
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  changeDateType({ commit }, datetype) {
    localStorage.setItem("datetype", datetype);
    commit("setDateType", datetype);
  },
  logout({ commit }) {
    return new Promise((resolve, reject) => {
      commit("logout");
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("role");
      localStorage.removeItem("usermenu");
      localStorage.removeItem("settings");
      localStorage.removeItem("datetype");
      localStorage.removeItem("inboxcount");
      localStorage.removeItem("company");
      delete axios.defaults.headers.common["Authorization"];
      resolve();
    });
  },
  refreshtoken({ commit }) {
    axios
      .get("/refresh")
      .then((response) => {
        const token = response.data.access_token;
        localStorage.setItem("token", token);
        axios.defaults.headers.common["Authorization"] = "Bearer " + token;
        commit("auth_success", { token });
      })
      .catch((error) => {
        console.log("refresh token error");
        commit("logout");
        localStorage.removeItem("token");
        console.log(error);
      });
  },
  showSuccessMessage({ commit }, message) {
    const snackbar = {
      color: "success",
      show: true,
      message: message,
    };
    commit("setSnackbar", snackbar);
  },
  showErrorMessage({ commit }, message) {
    const snackbar = {
      color: "error",
      show: true,
      message: message,
    };
    commit("setSnackbar", snackbar);
  },
  setPageTitle({ commit }, title) {
    commit("setPageTitle", title);
  },
  setMessage({ commit }, message) {
    commit("setMessage", message);
  }
};
